export const SPEND_LIMIT_ID = 1;
export const SYSTEM_CREDIT_ID = 2;
export const PROMO_CODES_ID = 3;
export const PRE_PAY_ID = 4;
